// extracted by mini-css-extract-plugin
export var fadeIn = "_gx-1";
export var modalContent = "_gx-3";
export var overlay = "_gx-0";
export var popoverContent = "_gx-2";
export var results = "_gx-5";
export var searchInputWrapper = "_gx-4";